export default __webpack_public_path__ + "static/media/text.3466e59d.svg";